import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DiscFullIcon(props: IconProps) {
    return <Icon {...props} iconKey={"disc_full"}/>
}
